import React, { useState } from 'react';
import { AppBar, Toolbar, IconButton, Button, Menu, MenuItem, Divider } from '@mui/material';
import PersonIcon from '@mui/icons-material/Person';
import LoginIcon from '@mui/icons-material/Login';
import { useNavigate, useLocation } from 'react-router-dom';
import { useOktaAuth } from '@okta/okta-react';
import '../../Styles/Components/NavMenu.css';
import ThemeToggle from './ThemeToggle';

const NavMenu = ({ isDarkMode, toggleTheme }) => {
  const [anchorEl, setAnchorEl] = useState(null); // For user menu
  const navigate = useNavigate();
  const location = useLocation();
  const { authState, oktaAuth } = useOktaAuth();

  // Use Okta's authentication state
  const isLoggedIn = authState?.isAuthenticated;

  // Get user info from Okta claims if available
  const userData = isLoggedIn && authState?.idToken?.claims ? {
    username: authState.idToken.claims.name || authState.idToken.claims.email || 'User',
    role: 'User', // You can add role-based logic here if needed
  } : null;

  const items = [
    { icon: 'info', text: 'Information', path: '/Information', admin: false },
    { icon: 'launch', text: 'Launch', path: '/Launch', admin: false },
    { icon: 'view_list', text: 'Games', path: '/Games', admin: false },
    { icon: 'computer', text: 'Settings', path: '/Settings', admin: false },
    { icon: 'computer', text: 'Features', path: '/Features', admin: false },
    { icon: 'computer', text: 'Orders', path: '/Orders', admin: false },
    { icon: 'computer', text: 'Monitoring', path: '/Monitoring', admin: false },
    { icon: 'computer', text: 'BetSettings', path: '/BetSettings', admin: false },
  ];

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = async () => {
    setAnchorEl(null);
    try {
      await oktaAuth.signOut({
        postLogoutRedirectUri: window.location.origin + '/callback'
      });
    } catch (err) {
      console.error('Error during logout:', err);
      navigate('/');
    }
  };

  const handleLogin = () => {
    navigate('/login');
  };

  // Check if button is the current route
  const isCurrentRoute = (path) => {
    return location.pathname === path;
  };

  // Handle nav button click
  const handleNavClick = (item) => {
    // If admin route and not logged in, prompt to login
    if (item.admin && !isLoggedIn) {
      handleLogin();
    } else {
      navigate(item.path);
    }
  };

  return (
    <AppBar position="static" color="primary">
      <Toolbar className="nav-toolbar">
        <div
          className="toplogo"
          onClick={() => navigate('/')}
          style={{ cursor: 'pointer' }}
        >
          <span>Casino<span style={{ fontWeight: 'bold' }}>Portal</span></span>
        </div>

        <div className="toplink">
          {items.map((item, index) => (
            <Button
              key={index}
              color="inherit"
              onClick={() => handleNavClick(item)}
              disabled={isCurrentRoute(item.path)}
              className={item.admin && !isLoggedIn ? "admin-nav-button" : ""}
            >
              {item.text}
            </Button>
          ))}
        </div>

        <div className="nav-actions">
          {isLoggedIn ? (
            // User is logged in
            <IconButton color="inherit" onClick={handleMenuOpen}>
              <PersonIcon style={{ marginRight: '5px' }} />
              {userData?.username || 'User'}
            </IconButton>
          ) : (
            // User is not logged in
            <IconButton color="inherit" onClick={handleLogin}>
              <LoginIcon style={{ marginRight: '5px' }} />
              Login
            </IconButton>
          )}

          <Menu
            anchorEl={anchorEl}
            keepMounted
            open={Boolean(anchorEl)}
            onClose={handleMenuClose}
          >
            {isLoggedIn && (
              <>
                <MenuItem onClick={() => { navigate('/profile'); handleMenuClose(); }}>Profile</MenuItem>
                <MenuItem onClick={() => { console.log('Refreshing...'); handleMenuClose(); }}>Refresh Cache</MenuItem>
                <Divider />
                <MenuItem onClick={handleLogout}>Logout</MenuItem>
              </>
            )}
          </Menu>

          {/* Theme Toggle Button */}
          <ThemeToggle isDark={isDarkMode} onToggle={toggleTheme} />
        </div>
      </Toolbar>
    </AppBar>
  );
};

export default NavMenu;